import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import projectProperties_toJSON from "../functions/properties-to-json";
import ProjectSession from "../../project-session";
import {ProjectPropertiesData} from "../../types"

const DEFAULT = {
    canCreateTask           : false,
    canCreateProject        : false,
    canCreateLink           : false,
    canCreateEmbed          : false,
    canCreateMeeting        : false,
    canCreateEvent          : false,
    canCreateDiscussion     : false,
    canCreateDocument       : false,
    canCreateGoal           : true,
    canCreateDashboard      : false,
    canCreateRequestForms   : false,
    canCreateAttachments    : false,
}

export default class ProjectSingleViewProperties extends ProjectProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canCreateTask                      = false
        this.canCreateProject                   = false
        this.canCreateLink                      = false
        this.canCreateEmbed                     = false
        this.canCreateMeeting                   = false
        this.canCreateEvent                     = false
        this.canCreateDiscussion                = false
        this.canCreateDocument                  = false
        this.canCreateGoal                      = false
        this.canCreateDashboard                 = false
        this.canCreateRequestForms              = false
        this.canCreateAttachments               = false
        this.canArchive                         = true
        this.canHaveStatus                      = true

        this.menuSections.reports               = false
        this.menuSections.integrations          = false
        this.menuSections.automations           = false
        this.menuSections.customers             = false
        this.menuSections.settings              = false

        this.settingsSections.workItems         = false
        this.settingsSections.customFields      = false
        this.settingsSections.views             = false
        this.settingsSections.taskId            = false
        this.settingsSections.navigation        = false
        this.settingsSections.taskTypes         = false
        this.settingsSections.workflow          = false
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        return {
            pinStar         : true,
            info            : true,
            users           : true,
            settings        : false,
            status          : false,
            archive         : true,
            history         : false,
            rename          : true,
            editSource      : false,
            colorIcon       : true,
            move            : true,
            convert         : false,    // no convert please
            duplicate       : false,    // if change to true you need backend update !!!!!
            saveAsTemplate  : false,     // no save as template
            delete          : true,
            directLink      : true,
            showInMenu      : true,     // display in main menu
        }
    }

    /*get handleExpandInsteadOfOpen() {
        return true
    }*/

    toJSON(): ProjectPropertiesData {
        return projectProperties_toJSON(this, DEFAULT)
    }
}
